import {Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';

@Component({
    standalone: true,
    selector: 'app-app-mobile',
    templateUrl: './app-mobile.component.html',
    styleUrls: ['./app-mobile.component.scss'],
    imports: [MatCardModule, MatButtonModule, RouterLink]
})
export class AppMobileComponent {}
